import React from 'react';
import { styled } from '@mui/material';
import { Colors } from 'library';

interface RCardHeaderButtonProps {
    icon: React.ReactNode;
    label: string;
    onClick?: () => void;
    children?: React.ReactNode;
}

export function RCardHeaderButton({ icon, label, onClick, children }: RCardHeaderButtonProps) {
    return (
        <Button onClick={onClick}>
            {icon}
            {label}
            {children}
        </Button>
    );
}

const Button = styled('button')({
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    background: 'none',
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 20,
    cursor: 'pointer',
    fontSize: 14,
    color: Colors.mediumGrey,
    padding: '6px 16px',
    whiteSpace: 'nowrap',
    '&:focus, &:focus-visible': {
        outline: 'none',
    },
    '&:hover': {
        color: Colors.darkNavy,
        backgroundColor: Colors.faintGrey,
        borderColor: Colors.faintGrey,
    },
});
